import React from 'react';
import { COLORS } from './landingData';

export function ShowcaseSection({ lang }) {
  return (
    <section style={{ padding: '56px 0 0', background: COLORS.surface, textAlign: 'center' }} data-testid="partnership-section">
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '0 24px' }}>
        <span style={{
          fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, letterSpacing: '0.15em',
          color: COLORS.accent, textTransform: 'uppercase',
        }}>
          {lang === 'en' ? 'BUILT FOR RELATIONSHIPS' : lang === 'ru' ? 'СОЗДАНО ДЛЯ ПАРТНЁРСТВА' : 'БАРОИ ҲАМКОРӢ СОХТАШУДА'}
        </span>
        <h2 style={{
          fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(26px, 3.5vw, 38px)', fontWeight: 800,
          color: COLORS.text, marginTop: 8, lineHeight: 1.2, marginBottom: 0,
        }}>
          {lang === 'en' ? 'Where Pharmacies & Distributors Thrive Together' : lang === 'ru' ? 'Где аптеки и дистрибьюторы процветают вместе' : 'Доруханаҳо ва дистрибюторҳо якҷоя рушд мекунанд'}
        </h2>
      </div>

      {/* 3-Card Showcase Grid */}
      <div className="showcase-grid" data-testid="showcase-cards" style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16,
        maxWidth: 1200, margin: '36px auto 0', padding: '0 24px', textAlign: 'left',
      }}>
        {/* Card 1: Mobile App */}
        <div data-testid="showcase-card-mobile" style={{
          borderRadius: 22, height: 520, position: 'relative', overflow: 'hidden',
          background: 'linear-gradient(160deg, #d4e8de 0%, #a8d5ba 40%, #2E8B6E 100%)',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', paddingTop: 28, minHeight: 0 }}>
            <div style={{
              width: 220, background: '#111', borderRadius: 32, padding: '10px 6px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.1)',
              position: 'relative',
            }}>
              <div style={{
                position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)',
                width: 70, height: 20, background: '#111', borderRadius: 14, zIndex: 10,
              }}/>
              <div style={{ borderRadius: 26, overflow: 'hidden', background: '#fff', height: '100%' }}>
                <div style={{ background: COLORS.primary, padding: '18px 14px 8px', display: 'flex', alignItems: 'center' }}>
                  <span style={{ color: '#fff', fontFamily: 'Outfit, sans-serif', fontSize: 13, fontWeight: 800 }}>Pharm-X</span>
                  <span style={{ marginLeft: 'auto', width: 8, height: 8, borderRadius: '50%', background: '#4ade80' }}/>
                </div>
                <div style={{ padding: '10px 12px' }}>
                  <div style={{ fontSize: 10, color: COLORS.textMuted, fontWeight: 600, marginBottom: 8 }}>Dashboard</div>
                  <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                    <div style={{ flex: 1, background: COLORS.sage, borderRadius: 10, padding: '10px 6px', textAlign: 'center' }}>
                      <div style={{ fontSize: 22, fontWeight: 800, color: COLORS.primary }}>24</div>
                      <div style={{ fontSize: 7, color: COLORS.textSecondary, marginTop: 2 }}>Partners</div>
                    </div>
                    <div style={{ flex: 1, background: '#fef3c7', borderRadius: 10, padding: '10px 6px', textAlign: 'center' }}>
                      <div style={{ fontSize: 22, fontWeight: 800, color: '#92400e' }}>150</div>
                      <div style={{ fontSize: 7, color: '#92400e', marginTop: 2 }}>Deliveries</div>
                    </div>
                  </div>
                  {[{ name: 'Drug Dushanbe', val: '25 stock', c: COLORS.secondary },
                    { name: 'Drug Khujand', val: '18 stock', c: COLORS.secondary },
                    { name: 'Low Stock alert', val: 'Low stock', c: '#f59e0b' },
                    { name: 'Drug Somita', val: '25 stock', c: COLORS.secondary }].map((r, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '5px 0', borderBottom: i < 3 ? '1px solid #f0f0f0' : 'none', fontSize: 8, color: COLORS.text }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: r.c, flexShrink: 0 }}/>
                      <span style={{ flex: 1, fontWeight: 500 }}>{r.name}</span>
                      <span style={{ color: r.c === '#f59e0b' ? '#f59e0b' : COLORS.textMuted, fontSize: 7 }}>{r.val}</span>
                    </div>
                  ))}
                  <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 12, paddingTop: 8, borderTop: '1px solid #e5e7eb' }}>
                    {[{ icon: '\u229E', label: 'Home', active: true }, { icon: '\u22A1', label: 'Stock' }, { icon: '\u229F', label: 'Delivery' }, { icon: '\u2630', label: 'More' }].map((tab, i) => (
                      <div key={i} style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, color: tab.active ? COLORS.secondary : COLORS.textMuted, lineHeight: 1 }}>{tab.icon}</div>
                        <div style={{ fontSize: 6, color: tab.active ? COLORS.secondary : COLORS.textMuted, marginTop: 2, fontWeight: tab.active ? 700 : 400 }}>{tab.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ padding: '12px 24px 28px', width: '100%' }}>
            <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(20px, 2.2vw, 26px)', fontWeight: 800, color: COLORS.primary, margin: 0, lineHeight: 1.15 }}>
              {lang === 'en' ? 'Pharm-X Mobile App' : lang === 'ru' ? 'Мобильное приложение' : 'Барномаи мобилӣ'}
            </h3>
            <p style={{ fontFamily: 'Outfit, sans-serif', fontSize: 14, color: 'rgba(26,58,40,0.65)', margin: '6px 0 0', lineHeight: 1.4 }}>
              {lang === 'en' ? 'Manage everything from your phone' : lang === 'ru' ? 'Управляйте всем с телефона' : 'Ҳамаро аз телефон идора кунед'}
            </p>
          </div>
        </div>

        {/* Card 2: Happy Pharmacies */}
        <div data-testid="showcase-card-pharmacies" style={{
          borderRadius: 22, height: 520, position: 'relative', overflow: 'hidden',
        }}>
          <img src="/card2-pharmacies.png" alt="Pharmacist holding Pharm-X tablet in pharmacy" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 20%', display: 'block' }}/>
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.3) 55%, transparent 100%)',
            padding: '100px 24px 28px',
          }}>
            <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(20px, 2.2vw, 26px)', fontWeight: 800, color: '#fff', margin: 0, lineHeight: 1.15 }}>
              {lang === 'en' ? 'Happy Pharmacies' : lang === 'ru' ? 'Довольные аптеки' : 'Доруханаҳои хурсанд'}
            </h3>
            <p style={{ fontFamily: 'Outfit, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.8)', margin: '6px 0 0', lineHeight: 1.4 }}>
              {lang === 'en' ? 'Clear accounts, timely deliveries, zero confusion' : lang === 'ru' ? 'Прозрачные счета, своевременные доставки' : 'Ҳисобҳои шаффоф, расонидани саривақтӣ'}
            </p>
          </div>
        </div>

        {/* Card 3: Growing Together */}
        <div data-testid="showcase-card-growing" style={{
          borderRadius: 22, height: 520, position: 'relative', overflow: 'hidden',
        }}>
          <img src="https://images.pexels.com/photos/5466250/pexels-photo-5466250.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Growing Together" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}/>
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.3) 55%, transparent 100%)',
            padding: '100px 24px 28px',
          }}>
            <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(20px, 2.2vw, 26px)', fontWeight: 800, color: '#fff', margin: 0, lineHeight: 1.15 }}>
              {lang === 'en' ? 'Growing Together' : lang === 'ru' ? 'Растём вместе' : 'Якҷоя рушд мекунем'}
            </h3>
            <p style={{ fontFamily: 'Outfit, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.8)', margin: '6px 0 0', lineHeight: 1.4 }}>
              {lang === 'en' ? 'Real-time data helps both sides make better decisions' : lang === 'ru' ? 'Данные в реальном времени помогают обеим сторонам' : 'Маълумоти вақти воқеӣ ба ҳар ду тараф кӯмак мекунад'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
